import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { User } from '../../shared/models/user.model';

@Injectable({ providedIn: 'root' })
export class SsoAuthService {
  constructor(private http: HttpClient) {}

  /**
   * Fetches the Azure AD authorization URL from the backend and redirects the browser to it.
   * The frontend never sees Azure AD tokens — the backend handles the code exchange.
   * State generation and CSRF validation are handled server-side by Spring Security OAuth2.
   * On success, Azure AD redirects to {frontend-url}/login/oauth2/code/company-sso.
   */
  loginWithMicrosoft(): void {
    this.http.get<{ url: string }>(environment.sso.authorizationUrl).subscribe({
      next: ({ url }) => this.redirect(url),
      error: (err) => {
        console.error('Failed to fetch SSO authorization URL:', err);
      },
    });
  }

  /**
   * Exchanges the OAuth2 code and state with the backend.
   * On success the backend issues an HMAC JWT as an HttpOnly cookie
   * and returns the authenticated user's profile.
   */
  handleCallback(code: string, state: string): Observable<{ success: boolean; user: User }> {
    return this.http.get<{ success: boolean; user: User }>(environment.sso.callback, {
      params: { code, state },
      withCredentials: true,
    });
  }

  protected redirect(url: string): void {
    window.location.href = url;
  }
}
